/** @format */
import { AccordionModule, ToolTipModule } from '@shared/components';

import { GoldMemberStatusComponent } from './gold-member-status.component';
import { NgModule } from '@angular/core';
import { ScorecardGoldModule } from '../scorecard-gold/scorecard-gold.module';

@NgModule({
	imports: [AccordionModule, ScorecardGoldModule, ToolTipModule],
	declarations: [GoldMemberStatusComponent],
	exports: [GoldMemberStatusComponent, ToolTipModule]
})
export class GoldMemberStatusModule {}
